// @flow

import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

type Props = {
  switchCheckboxStyles?: string,
  switchLabelStyles?: string,
  switchButtonStyles?: string,
  isOn: boolean,
  handleToggle: () => void,
  disabled?: boolean,
}

const Switch = ({
  isOn,
  handleToggle,
  switchLabelStyles = '',
  switchButtonStyles = '',
  switchCheckboxStyles = '',
  disabled = false,
}: Props) => (
  <div className={styles.switchWrapper}>
    <input
      checked={isOn}
      className={cn(styles.switchCheckbox, switchCheckboxStyles)}
      type="checkbox"
    />
    {/* eslint-disable-next-line max-len */}
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */}
    <label
      style={{ background: isOn && '#FF1738' }}
      className={cn(styles.switchLabel, switchLabelStyles, (disabled ? styles.disabled : ''))}
      onClick={handleToggle}
    >
      <span className={cn(styles.switchButton, switchButtonStyles)} />
    </label>
  </div>
);

export default Switch;
